import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { FaqIndexSelectComponent } from './crud-index/crud-index-select.component';
import { FaqIndexComponent } from './crud-index/crud-index.component';
import { FaqCrudIndex } from './crud-index/crud-index';
import { FaqCESComponent } from './crud-ces/crud-ces.component';
import { FaqService } from './crud-service';
import { FaqRoutingModule } from './faq-routing.module';
import { FaqTableModule } from './crud-index/faq-table/faq-table.module';
import { FaqResponseDialogComponent } from './faq-response-dialog/faq-response-dialog.component';
import { EventsTableModule } from '../events-forms/crud-index/events-table/events-table.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { FilterFaqDialogComponent } from './filter-faq-dialog/filter-faq-dialog.component';

@NgModule({
  declarations: [
    FaqCESComponent,
    FaqCrudIndex,
    FaqIndexComponent,
    FaqIndexSelectComponent,
    FaqResponseDialogComponent,
    FilterFaqDialogComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FaqRoutingModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    FaqTableModule,
    EventsTableModule,
    LayoutCrudIndexModule
],
  providers: [FaqService],
})
export class FaqModule {}
